/** Solo URLs http(s), o la ruta same-origin que recolorea el destacado semanal. */
const WEEKLY_IMAGE_PATH = "/api/v1/pulse/weekly-image?";

export function toSafeHttpUrl(url: string | null | undefined): string | null {
  if (!url?.trim()) return null;
  const trimmed = url.trim();
  if (trimmed.startsWith(WEEKLY_IMAGE_PATH)) return trimmed;
  try {
    const parsed = new URL(url.trim());
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      return parsed.href;
    }
  } catch {
    /* invalid */
  }
  return null;
}

const EMBED_HOSTS = new Set([
  "www.youtube.com",
  "youtube.com",
  "youtube-nocookie.com",
  "www.youtube-nocookie.com",
  "player.vimeo.com",
  "cdn.jwplayer.com",
]);

/** Allowlisted iframe embed URLs (YouTube / Vimeo / JW Player only). */
export function toSafeVideoEmbedUrl(url: string | null | undefined): string | null {
  const safe = toSafeHttpUrl(url);
  if (!safe) return null;
  try {
    const parsed = new URL(safe);
    const host = parsed.hostname.toLowerCase();
    if (!EMBED_HOSTS.has(host)) return null;
    if (host.includes("youtube") && !parsed.pathname.startsWith("/embed/")) {
      return null;
    }
    if (host === "player.vimeo.com" && !parsed.pathname.startsWith("/video/")) {
      return null;
    }
    if (host === "cdn.jwplayer.com" && !parsed.pathname.startsWith("/players/")) {
      return null;
    }
    return parsed.href;
  } catch {
    return null;
  }
}

export function getDomainLabel(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}

/** Etiqueta legible: medio / dominio de la URL. */
export function formatSourceDisplayName(sourceLabel: string, url: string): string {
  const label = sourceLabel?.trim();
  if (label) return label;
  return getDomainLabel(url);
}

export function faviconUrl(url: string): string {
  const domain = getDomainLabel(url);
  return `https://www.google.com/s2/favicons?sz=32&domain_url=${encodeURIComponent(domain)}`;
}
